<template>
  <div class="data-tree">
    <el-dialog :visible.sync="state.deleteDialogVisible">
      <p>Вы действительно хотите удалить объект?</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="state.deleteDialogVisible = false">Отменить</el-button>
        <el-button type="primary" @click="doDelete()">Подтвердить</el-button>
      </div>
    </el-dialog>

    <el-input class="data-tree__filter-input" v-if="filtration && data.length" placeholder="Фильтрация"
              v-model="state.filterText"></el-input>

    <el-tree :data="data" :expand-on-click-node="false"
             :filter-node-method="filterNode" ref="tree"
             :auto-expand-parent="autoExpandParent"
             :default-expanded-keys="defaultExpandedKeys" :props="props"
             :node-key="nodeKey">
      <div style="width: 100%;" slot-scope="{node, data}">
        <slot name="row" v-if="$scopedSlots.row" :node="node" :data="data"></slot>
        <slot name="row" v-if="!$scopedSlots.row">
          {{filterProp ? data[filterProp] : node.label}}
        </slot>
        <span class="el-tree__buttons">
          <i class="el-icon-edit cursor_pointer" @click="onEdit(data, node)" v-if="actions.includes('edit')"></i>
          <i class="el-icon-delete cursor_pointer" @click="askDelete(data, node)"
             v-if="actions.includes('delete') || data.onDelete"></i>
        </span>
      </div>
    </el-tree>
  </div>

</template>

<script>
  export default {
    data: () => ({
      state: {
        deleteDialogVisible: false,
        filterText: ''
      }
    }),
    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      },
      defaultExpandedKeys: {
        type: Array,
        default() {
          return []
        }
      },
      nodeKey: {
        type: String,
        default: 'id'
      },
      props: {
        type: Object,
        default: () => ({})
      },
      module: String,
      actions: {
        type: Array,
        default: () => ([])
      },
      filtration: Boolean,
      customFilterMethod: Function,
      filterProp: String,
      autoExpandParent: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      'state.filterText': {
        handler(val) {
          this.$refs.tree.filter(val);
        }
      }
    },
    created() {
    },
    methods: {
      onEdit(data, node) {
        this.$router.push({name: `${this.module}.edit`, params: {id: data.id}})
      },
      askDelete(data, node) {
        this.state.deleteDialogVisible = true
        this.state.itemToDelete = {node, data}
      },
      doDelete() {
        this.state.deleteDialogVisible = false
        if (this.state.itemToDelete.data.onDelete) {
          this.state.itemToDelete.data.onDelete(this.state.itemToDelete)
        } else {
          this.$emit('on-delete', this.state.itemToDelete)
        }
      },
      filterNode(value, data, node) {
        if (this.customFilterMethod) {
          return this.customFilterMethod(value, data, node)
        }
        if (!value) return true

        let filterProp = this.filterProp ? this.filterProp : 'label'
        let includes = data[filterProp].toLowerCase().indexOf(value.toLowerCase()) !== -1

        return includes || this.checkNodeParent({node, filterProp, value})
      },
      checkNodeParent({node, filterProp, value}) {
        if (!node.parent || !node.parent.data[filterProp]) {
          return false
        }

        let includes = node.parent.data[filterProp].toLowerCase().indexOf(value.toLowerCase()) !== -1

        if (node.parent.parent) {
          return includes || this.checkNodeParent({node: node.parent, filterProp, value})
        } else {
          return includes
        }
      }
    }
  }
</script>

<style lang="scss">
  .data-tree {
    &__filter-input {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DataTree/index.vue